import React, { useMemo, useRef } from "react";
import { Route, useHistory } from "react-router-dom";
import { ObjectsLoadingDialog } from "./objects-loading-dialog/ObjectsLoadingDialog";
import { ObjectDeleteDialog } from "./object-delete-dialog/ObjectDeleteDialog";
import { ObjectsDeleteDialog } from "./objects-delete-dialog/ObjectsDeleteDialog";
import { ObjectsFetchDialog } from "./objects-fetch-dialog/ObjectsFetchDialog";
import { ObjectsUpdateStatusDialog } from "./objects-update-status-dialog/ObjectsUpdateStatusDialog";
import { ObjectsCard } from "./ObjectsCard";
import { ObjectsUIProvider } from "./ObjectsUIContext";
import { FilterObjectsUIProvider } from "./FilterObjectsUIContext";
import { AuditFormResultDialog } from "./objects-update-status-dialog/AuditFormResultDialog";
import { ObjectRefreshDialog } from "./object-refresh-dialog/ObjectRefreshDialog";
import { ObjectsHardDeleteDialog } from "./objects-delete-dialog/ObjectsHardDeleteDialog";
import { UserChangePassDialog } from "../../../../../app/modules/BaseInfo/user/user-edit/UserChangePassDialog";
import ReactToPrint, { useReactToPrint } from "react-to-print";



const ObjectsPage = ({
  AuditAction,
  haveGeneralAction = true,
  groupSettingAction = false,
  haveChangePasswordAction = false,
  haveStimulsoftReport = false,
  isFullAccess,
  basePath,
  api,
  getFunctionName,
  currentState,
  columns,
  prepareFilter,
  filterFields,
  filterInitialValues,
  softDelete = true,
  filterByShowButton = false,
  parentId,
  prentName,
  haveSaveAllButton = false,
  hideSelected = false,
  checkActive = false,
  rowFormatter,
  showAuditResultForm = false,
  haveExportButton = false,
  exportfuncName,
  enablePagination = true,
  detailColumns,
  setParentData,
  setDetailData,
  mrtUrl,
  jsonFileName
}) => {
  //console.log("basePath : " + basePath)

  // const componentRef = useRef();
  // const handlePrint = () => {
  //   // var content = document.getElementById("divcontents");
  //   // var pri = document.getElementById("ifmcontentstoprint").contentWindow;
  //   // pri.document.open();
  //   // pri.document.write(content.innerHTML);
  //   // pri.document.close();
  //   // pri.focus();
  //   // pri.print();
  // }

  const history = useHistory()
  //console.log("history : " + history)
  const ObjectsUIEvents = {
    newObjectButtonClick: () => {
      history.push(`${basePath}/new`);
    },
    openEditObjectPage: (id) => {
      history.push(`${basePath}/${id}/edit`);
    },
    openFloorsPage: (id, buildingTitle) => {
      history.push(`${basePath}/${id}/${buildingTitle}/floors`);
    },
    openRoomsPage: (id, floorTitle) => {
      history.push(`${basePath}/${id}/${floorTitle}/rooms`);
    },

    openAttendenceSettingPage: (id) => {
      history.push(`${basePath}/${id}/attendence`);
    },

    openDeleteObjectDialog: (id) => {
      history.push(`${basePath}/${id}/delete`);
    },
    openRefreshObjectDialog: (id) => {
      history.push(`${basePath}/${id}/refresh`);
    },
    openDeleteObjectsDialog: () => {
      history.push(`${basePath}/deleteAll`);
    },
    openHardDeleteObjectsDialog: () => {
      history.push(`${basePath}/hardDeleteAll`);
    },
    openFetchObjectsDialog: () => {
      history.push(`${basePath}/fetch`);
    },
    openUpdateObjectsStatusDialog: () => {
      history.push(`${basePath}/updateStatus`);
    },
    openAuditOptionDialog: (id) => {
      history.push(`${basePath}/${id}/updateAnswer`);
    },
    openChangePassObjectsDialog: () => {
      history.push(`${basePath}/changePass`);
    },
  };


  return (

    // <FilterObjectsUIProvider>
    <ObjectsUIProvider ObjectsUIEvents={ObjectsUIEvents} >
      <ObjectsLoadingDialog listLoading={currentState.listLoading} />

      <Route path={`${basePath}/deleteAll`}>
        {({ history, match }) => (
          <ObjectsDeleteDialog
            show={match != null}
            onHide={() => {
              history.push(basePath);
            }}
            ObjectsDeleteDialog={ObjectsDeleteDialog}
            currentState={currentState}
            api={api}
            softDelete={softDelete}
          />
        )}
      </Route>
      <Route path={`${basePath}/hardDeleteAll`}>
        {({ history, match }) => (
          <ObjectsHardDeleteDialog
            show={match != null}
            onHide={() => {
              history.push(basePath);
            }}
            ObjectsDeleteDialog={ObjectsHardDeleteDialog}
            currentState={currentState}
            api={api}
            softDelete={false}
          />
        )}
      </Route>
      <Route path={`${basePath}/:id/delete`}>
        {({ history, match }) => (
          <ObjectDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push(basePath);
            }}
            ObjectsDeleteDialog={ObjectsDeleteDialog}
            currentState={currentState}
            api={api}
            softDelete={softDelete}
          />
        )}
      </Route>
      <Route path={`${basePath}/:id/refresh`}>
        {({ history, match }) => (
          <ObjectRefreshDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push(basePath);
            }}
            ObjectRefreshDialog={ObjectRefreshDialog}
            currentState={currentState}
            softDelete={softDelete}
            api={api}
          />
        )}
      </Route>
      <Route path={`${basePath}/fetch`}>
        {({ history, match }) => (
          <ObjectsFetchDialog
            show={match != null}
            onHide={() => {
              history.push(basePath);
            }}
            currentState={currentState}
            api={api}
          />
        )}
      </Route>
      <Route path={`${basePath}/updateStatus`}>
        {({ history, match }) => (
          <ObjectsUpdateStatusDialog
            show={match != null}
            onHide={() => {
              history.push(basePath);
            }}
            currentState={currentState}
            api={api}
          />
        )}
      </Route>
      <Route path={`${basePath}/:id/updateAnswer`}>
        {({ history, match }) => (
          <AuditFormResultDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push(basePath);
            }}
            currentState={currentState}
            api={api}
          />
        )}
      </Route>
      <Route path={`${basePath}/changePass`}>
        {({ history, match }) => (
          <UserChangePassDialog
            show={match != null}
            onHide={() => {
              history.push(basePath);
            }}
            UserChangePassDialog={UserChangePassDialog}
            currentState={currentState}
            api={api}
            softDelete={softDelete}
            getQueryFunctionName={getFunctionName}
          />
        )}
      </Route>

      {/* <iframe id="ifmcontentstoprint" style="height: 0px; width: 0px; position: absolute"></iframe>

      <div id="divcontents"> */}
      <ObjectsCard
        showAuditResultForm={showAuditResultForm}
        rowFormatter={rowFormatter}
        checkActive={checkActive}
        hideSelected={hideSelected}
        getFunctionName={getFunctionName}
        AuditAction={AuditAction}
        filterByShowButton={filterByShowButton}
        haveGeneralAction={haveGeneralAction}
        groupSettingAction={groupSettingAction}
        isFullAccess={isFullAccess}
        api={api}
        basePath={basePath}
        currentState={currentState}
        columns={columns}
        prepareFilter={prepareFilter}
        filterFields={filterFields}
        filterInitialValues={filterInitialValues}
        parentId={parentId}
        prentName={prentName}
        haveSaveAllButton={haveSaveAllButton}
        haveChangePasswordAction={haveChangePasswordAction}
        enablePagination={enablePagination}
        haveExportButton={haveExportButton}
        exportfuncName={exportfuncName}
        detailColumns={detailColumns}
        setParentData={setParentData}
        setDetailData={setDetailData}
        haveStimulsoftReport={haveStimulsoftReport}
        mrtUrl={mrtUrl}
        jsonFileName={jsonFileName}
      />
      {/* </div> */}
      {/* <button onClick={handlePrint}>Print this out!</button> */}



    </ObjectsUIProvider>
    // </FilterObjectsUIProvider>
  );
}

export default ObjectsPage;


